import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { useBreakpoints } from 'hooks';
import { useBusinessToolSessionStore } from 'store/useBusinessToolStore';
import { getBusinessToolMode } from 'store/useBusinessToolStore/selectors';

import { checkIsPreviewMode } from 'pages/BusinessToolPage/utils';

import { useAuthenticated } from 'hooks/useAuthenticated';

import { useAuthModalsContext } from 'components/AuthModals';
import { useModalContext } from 'components/ModalManager';
import { SaveProjectModal } from 'components/SaveProjectModal/SaveProjectModal';

const SIXTY_SECONDS_IN_MS = 60000;

export const OfferToSaveTheDocument: React.FC = () => {
  const { isAuthenticated, isAuthConfiguring } = useAuthenticated();
  const { t } = useTranslation();
  const businessToolMode = useBusinessToolSessionStore(getBusinessToolMode);
  const isPreviewMode = checkIsPreviewMode(businessToolMode);

  const { showModal, hideModal } = useModalContext();
  const { isModalOpened: isAuthModalOpened } = useAuthModalsContext();
  const { isMobile } = useBreakpoints();

  useEffect(() => {
    if (isAuthenticated || isAuthConfiguring || isPreviewMode || isAuthModalOpened) {
      return;
    }

    const saveProjectModalHandler = () => {
      showModal(SaveProjectModal, {
        onClose: hideModal,
        title: isMobile ? t('pleaseSignUp') : t('saveNewProject'),
        description: isMobile ? t('signupToShareTheProject') : t('loginToSaveTheProject'),
      });
    };

    const timer = setTimeout(() => {
      saveProjectModalHandler();
    }, SIXTY_SECONDS_IN_MS);

    return () => clearTimeout(timer);
  }, [businessToolMode, isAuthenticated, isAuthConfiguring, isAuthModalOpened, isPreviewMode]);

  return null;
};
